import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";

const Profile = () => {
  const [profile, setProfile] = useState({
    fullName: "John Doe",
    email: "johndoe@example.com",
    mobile: "+91 9876543210",
  });

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleUpdate = () => {
    alert("Profile updated!");
  };

  return (
    <div className="min-h-screen  relative">
      {/* Background Image */}
      <div className="h-64 bg-cover bg-center" style={{ backgroundImage: "url('https://source.unsplash.com/random/1600x400?technology')" }}></div>

      {/* Profile Card */}
      <div className=" mx-auto bg-white rounded-lg shadow-lg p-6 mt-[-80px] relative z-10">
        {/* Profile Image */}
        <div className="flex justify-center relative">
          <div className="relative">
            <img
              src="https://i.pravatar.cc/150?img=12"
              alt="Profile"
              className="w-28 h-28 rounded-full border-4 border-white shadow-md object-cover"
            />
            <button className="absolute bottom-1 right-1 bg-blue-600 text-white p-1 rounded-full hover:bg-blue-700">
              <FaEdit size={14} />
            </button>
          </div>
        </div>

        {/* Form Fields */}
        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Full Name</label>
            <input
              type="text"
              name="fullName"
              value={profile.fullName}
              onChange={handleChange}
              className="w-full mt-1 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email Address</label>
            <input
              type="email"
              name="email"
              value={profile.email}
              onChange={handleChange}
              className="w-full mt-1 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
            <input
              type="text"
              name="mobile"
              value={profile.mobile}
              onChange={handleChange}
              className="w-full mt-1 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            onClick={handleUpdate}
            className="w-full bg-primary text-white py-2 px-4 rounded hover:bg-primary transition"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
